import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';

export const getAttributesFunc = createAsyncThunk("get attributes function",
  async (query = '', thunkAPI) => {
    try {
      const response = await api.get(`/dashboard/attributes${query}`);
      return response.data.data.attributes;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  });

const getAttributesSlicer = createSlice({
  name: "get attributes slicer",
  initialState: {
    loading: false,
    data: [],
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAttributesFunc.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.apiErrors = {};
    })
      .addCase(getAttributesFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.successMessage = action.payload?.message || "";

      })
      .addCase(getAttributesFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  },
});

export default getAttributesSlicer.reducer;
